import React, { useEffect, useState } from 'react';
import ReportsActionsMenu from '../actions/ReportsActionsMenu';
import { updateReportSnapshot } from "../../services/reports";
import { USER_ROLE } from '../../services/auth';
import { formatDMY } from '../../utils/datetime';

const ReportTable = ({ reports }) => {
  const role = localStorage.getItem(USER_ROLE);
  const isBranchUser = role === 'branch_user';

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setColumns(calculateColumns(reports));
    setRows(calculateRows(reports));
  }, []);

  const calculateColumns = (reports) => {
    const customer = reports?.length > 0 ? reports[0].customer : null;
    if (!customer) {
      return [];
    }
    return customer.mis_fields;
  };

  const calculateRows = (reports) => {
    const rows = reports.map(r => ({ ...r, edit_mode: false }));
    return rows;
  };

  const handleEdit = (report) => {
    setRows(prev =>
      prev.map(r =>
        r.id === report.id
          ? { ...r, edit_mode: true }
          : { ...r, edit_mode: false }
      )
    );
  };

  const handleSaveReport = async (report) => {
    const filtered = (rows.filter(r => r.id === report.id));
    if (filtered.length <= 0) {
      return;
    }
    const selected = filtered[0];
    try {
      const [err, response] = await updateReportSnapshot(selected.id, selected.snapshot_data);
      if (!err) {
        setRows(prev =>
          prev.map(r =>
            r.id === selected.id ? { ...r, edit_mode: false } : r
          )
        );
        return true;
      } else {
        console.error('Error updating report snapshot:', err);
        return false;
      }
    } catch (e) {
      console.error('Error updating report snapshot:', e);
      return false;
    }
  };

  const handleCancelReport = (report) => {
    const updatedRow = { ...report, edit_mode: false };
    setRows((prev) =>
      prev.map((r) => (r.id === report.id ? updatedRow : r))
    );
    return updatedRow;
  };

  return (
    <div className="hidden md:block bg-white shadow rounded overflow-x-auto">
      <table className="w-full text-sm text-left border">
        <thead className="bg-[#293686] text-white uppercase">
          <tr>
            {rows.length > 0 ? (
              <>
                {!isBranchUser && (
                  <th key={0} className="p-2 border text-center">Actions</th>
                )}
                {columns.map((col, i) => {
                  return <th key={i+1} className="p-2 border text-center">{col.column_name}</th>
                })}
              </>
            ) : (<></>)}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            <>
              {rows.map((report, i) => (
                <tr key={i} className="border-t">
                  {!isBranchUser && (
                    <td>
                      <div className="flex justify-center items-center">
                        <ReportsActionsMenu
                          report={report}
                          onEdit={handleEdit}
                          onSaveReport={handleSaveReport}
                          onCancelReport={handleCancelReport}
                        />
                      </div>
                    </td>
                  )}
                  {columns.map((col, j) => (
                    <td key={j} className="p-2 border text-center uppercase">
                      {!report.edit_mode ? (
                        col.key.toLowerCase().includes('date')
                          ? formatDMY(report.snapshot_data?.[col.key])
                          : report.snapshot_data?.[col.key]
                      ) : (
                        <input
                          type="text"
                          value={report.snapshot_data?.[col.key] ?? ""}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRows((prev) =>
                              prev.map((r) =>
                                r.id === report.id
                                  ? {
                                      ...r,
                                      snapshot_data: {
                                        ...r.snapshot_data,
                                        [col.key]: newValue,
                                      },
                                    }
                                  : r
                              )
                            );
                          }}
                          className="border border-gray-300 rounded px-2 py-1 text-sm w-full text-gray-700"
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-gray-500 py-2">
                No report data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
